export const aboutData = {
  brand: {
    title: "关于鬼父在线",
    subtitle: "正版高清资源直达平台",
    description: "鬼父在线成立于2020年，是国内领先的动漫资源导航与观看平台。我们致力于整合全球优质动漫资源，为用户提供便捷、安全、高质量的观影体验。经过多年的发展，鬼父在线已积累了超过10,000部高清动漫资源，服务超过500万活跃用户。",
    mission: "我们的使命是让每一位动漫爱好者都能轻松找到并观看自己喜欢的作品，不受地域和平台的限制。",
    vision: "成为全球动漫爱好者首选的资源导航与观看平台。",
    image: "https://readdy.ai/api/search-image?query=Anime%20studio%20office%20with%20creative%20workspace%2C%20warm%20natural%20lighting%20through%20windows%2C%20colorful%20anime%20posters%20on%20wall%2C%20modern%20Japanese%20style%20interior%20design%2C%20clean%20organized%20desk%20with%20computer%20screens%2C%20soft%20warm%20ambient%20atmosphere&width=600&height=400&seq=about-brand&orientation=landscape",
  },
  features: [
    { icon: "ri-shield-check-line", title: "正版授权", description: "所有资源均为官方正版授权，安全可靠" },
    { icon: "ri-movie-2-line", title: "海量资源", description: "超过10,000部高清动漫资源持续更新" },
    { icon: "ri-4k-line", title: "超清画质", description: "支持1080P至4K超清画质播放" },
    { icon: "ri-speed-up-line", title: "极速加载", description: "全球CDN加速，秒开不卡顿" },
    { icon: "ri-user-star-line", title: "优质服务", description: "7×24小时在线客服支持" },
    { icon: "ri-shield-star-line", title: "隐私保护", description: "全站HTTPS加密，保护用户隐私" },
  ],
  history: [
    { year: "2020", event: "鬼父在线平台正式上线，首批收录500部动漫资源" },
    { year: "2021", event: "平台资源突破3,000部，用户数突破100万，推出1080P高清专区" },
    { year: "2022", event: "上线分类导航系统，优化搜索体验，移动端适配完成" },
    { year: "2023", event: "资源量突破7,000部，用户突破300万，推出4K超清专区" },
    { year: "2024", event: "平台全面升级，引入AI智能推荐系统，用户突破400万" },
    { year: "2025", event: "资源量突破10,000部，活跃用户突破500万，成为行业领先平台" },
    { year: "2026", event: "持续优化用户体验，推出多项创新功能，引领行业发展" },
  ],
  honors: [
    { title: "2025年度最佳动漫平台", issuer: "中国动漫产业协会", year: "2025" },
    { title: "用户最喜爱的资源导航平台", issuer: "动漫爱好者联盟", year: "2025" },
    { title: "技术创新优秀企业", issuer: "数字内容产业联盟", year: "2024" },
    { title: "年度优质内容平台", issuer: "网络视听协会", year: "2024" },
  ],
  contact: {
    title: "联系我们",
    description: "如有任何问题或建议，欢迎通过以下方式与我们联系。我们的客服团队将在24小时内回复您。",
    email: "contact@balnsj.cn",
    phone: "400-888-6666",
    address: "北京市朝阳区动漫产业园区A座1001室",
    wechat: "guifuzaixian",
    qq: "1234567890",
    workingHours: "周一至周日 9:00 - 21:00",
  },
};

export const contactFaqData = [
  {
    question: "鬼父在线的客服工作时间是？",
    answer: "鬼父在线客服团队工作时间为周一至周日 9:00 - 21:00，全年无休。您可以通过在线客服、电子邮件或电话与我们取得联系。",
  },
  {
    question: "如何在鬼父在线提交反馈建议？",
    answer: "您可以通过「关于我们」页面中的联系方式发送邮件至 contact@balnsj.cn，或在微信公众号留言。我们非常重视每一位用户的反馈，会认真评估每一条建议。",
  },
  {
    question: "鬼父在线的版权声明是什么？",
    answer: "鬼父在线平台上所有资源均为正版授权内容。未经授权，禁止任何形式的转载、复制或商业使用。如需合作，请通过官方联系方式与我们洽谈。",
  },
];